<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="6">
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách danh mục</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col class="text-left" cols="5">
                <b-button class="btn-sm mr-50" variant="primary" @click="New()">
                  <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                  Thêm mới
                </b-button>
                <b-button class="btn-sm" variant="primary" @click="DeleteList()">
                  <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
                  Xóa
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                                :select-options="{ enabled: true }" :totalRows="totalRecords"
                                mode="remote"
                                @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                        <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                  @click="DeleteItem(props.row, props.row.id)">
                          <feather-icon icon="TrashIcon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <!-- Table Top -->
            <b-row class="pb-1">
              <b-col cols="12">
                <h4>Danh sách topic</h4>
              </b-col>
            </b-row>
            <b-row class="pb-1">
              <b-col class="text-left" cols="5">
                <b-button class="btn-sm mr-50" variant="primary" @click="NewTopic()">
                  <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                  Thêm mới
                </b-button>
                <b-button class="btn-sm " variant="primary" @click="DeleteTopic()">
                  <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
                  Xóa
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="searchQueryTopic" placeholder="Tìm kiếm "
                                v-on:keydown.enter="quickTopicSearch"/>
                  <b-input-group-append is-text role="button" @click="quickTopicSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table :columns="options.fieldSubs" :isLoading.sync="isLoading" :line-numbers="true" :rows="itemSubs"
                                :select-options="{ enabled: true }" :totalRows="totalRecordSubs"
                                mode="remote" @on-page-change="onPageChangeSub"
                                @on-sort-change="onSortChangeSub" @on-column-filter="onColumnSubFilter"
                                @on-per-page-change="onPerPageChangeSub"
                                @on-selected-rows-change="selectionChangedSub">
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Action -->
                    <span v-if="props.column.field === 'action'">
                      <span>
                        <b-button class="btn-icon" size="sm" variant="primary"
                                  @click="EditTopic(props.row, props.row.id)">
                          <feather-icon icon="Edit2Icon"/>
                        </b-button>
                        <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                  @click="DeleteItem(props.row, props.row.id)">
                          <feather-icon icon="TrashIcon"/>
                        </b-button>
                      </span>
                    </span>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Tên danh mục <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItem.name" :state="validateState('name')" placeholder="Nhập tên danh mục"
                            required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Loại danh mục<span class='text-danger'>*</span></label>
              <Select2 ref="catTypeNew" v-model="currentItem.cat_type_new" :options="typeCategories"
                       :state="validateState('cat_type_new')" class="cat-type-new" required
                       v-bind:class="{'readonly': editMode,'': !editMode }"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Trạng thái <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Thứ tự</label>
              <b-form-input v-model="currentItem.sort_order" max="9999999" min="0" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả danh mục">
              <b-form-textarea v-model="currentItem.description" k-max-length="500" max-rows="20"
                               placeholder="Mô tả danh mục" rows="8"/>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
    <b-modal id="modal-edit-topic" :title="getTitleTopic()" size="xl" @ok="handleTopicOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Danh mục <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItemSub.parent_id" :options="categoriesSelect" :state="validateStateSub('parent_id')"
                       required v-bind:class="{'readonly': editMode,'': !editMode }"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Tên topic <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItemSub.name" :state="validateStateSub('name')" minlength="3" placeholder="Nhập tên topic"
                            required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Trạng thái <span class='text-danger'>*</span></label>
              <Select2 v-model="currentItemSub.status" :options="statusList" :state="validateStateSub('status')"
                       required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Thứ tự</label>
              <b-form-input v-model="currentItemSub.sort_order" max="9999999" min="0" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả topic">
              <b-form-textarea id="textarea-auto-height" v-model="currentItemSub.description" max-rows="6"
                               placeholder="Mô tả topic" rows="6"/>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import {getuserName} from "@/@core/utils/utils";


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    validateStateSub(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItemSub[pro]) return false;
      else return true;
      return null;
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật danh mục ";
      } else {
        return "Thêm mới danh mục ";
      }
    },
    getTitleTopic() {
      if (this.editMode) {
        return "Cập nhật topic ";
      } else {
        return "Thêm mới topic ";
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    //sub
    updateSubParams(newProps) {
      this.serverSubParams = Object.assign({}, this.serverSubParams, newProps);
    },
    onPageChangeSub(params) {
      this.updateSubParams({page: params.currentPage});
      this.quickTopicSearch();
    },
    onPerPageChangeSub(params) {
      this.updateSubParams({pageSize: params.currentPerPage});
      this.quickTopicSearch();
    },
    onSortChangeSub(params) {
      this.updateSubParams({
        sort: params,
      });
      this.quickTopicSearch();
    },
    onColumnSubFilter(params) {
      this.serverSubParams.page = 1;
      this.updateSubParams(params);
      console.log(this.serverParams);
      this.quickTopicSearch();
    },
    //sub
    loadItems() {
      try {
        this.loading(true);
        useJwt
            .get("portal/categories", {
              columnFilters: {},
            })
            .then((response) => {
              this.loading(false);
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
              this.categoriesSelect = [];
              this.items.forEach(item => {
                this.categoriesSelect.push({'id': item.id, 'text': item.name});
              });
            });
      } catch {
        this.loading(false);
      }
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới danh mục ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật danh mục";
      this.$bvModal.show("modal-edit");
    },
    NewTopic() {
      this.currentItemSub = {};
      this.editMode = false;
      this.modal_title = "Thêm mới topic ";
      this.$bvModal.show("modal-edit-topic");
    },

    async EditTopic(item) {
      this.currentItemSub = item;
      this.editMode = true;
      this.modal_title = "Cập nhật topic";
      this.$bvModal.show("modal-edit-topic");
    },
    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/categories/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu danh mục",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadCategories();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá danh mục thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá danh mục ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
      this.quickTopicSearch();
    },
    async DeleteList() {
      if (this.rowSelection.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu danh mục",
          {title: "Please Confirm", size: "sm"}
      );

      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelection.length; i++) {
          listId.push(this.rowSelection[i].id);
        }
        const createParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deleteCategories", createParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa danh mục thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa danh mục ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChangedSub(params) {
      this.rowSelectionSub = params.selectedRows;
    },
    async DeleteTopic() {
      if (this.rowSelectionSub.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu topic",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelectionSub.length; i++) {
          listId.push(this.rowSelectionSub[i].id);
        }
        const createParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deleteCategories", createParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.quickTopicSearch();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa topic thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa topic ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }

      if (this.editMode) {

        const url = `portal/categories/${this.currentItem.id}`;

        const updateParams = {
          id: this.currentItem.id,
          name: this.currentItem.name,
          status: this.currentItem.status,
          parent_id: null,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          // cat_type_new: this.currentItem.cat_type_new,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật danh mục ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: this.currentItem.name,
          status: this.currentItem.status,
          parent_id: null,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          cat_type: 0,
          cat_type_new: this.currentItem.cat_type_new,
          updated_at: userName,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/categories", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới danh mục thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới danh mục ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async handleTopicOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      const parentId = this.currentItemSub.parent_id;
      const parent = this.items.filter(function (item) {
        return item.id == parentId
      })[0];
      if (Object.keys(parent).length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn danh mục.!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return;
      }
      this.currentItemSub.cat_type_new = parent.cat_type_new;
      this.isSubmit = true;
      const bIsValid = await this.isValid(this.currentItemSub);
      if (!bIsValid) {
        return;
      }

      if (this.editMode) {
        const url = `portal/categories/${this.currentItemSub.id}`;

        const updateParams = {
          id: this.currentItemSub.id,
          name: this.currentItemSub.name,
          status: this.currentItemSub.status,
          parent_id: this.currentItemSub.parent_id,
          sort_order: this.currentItemSub.sort_order,
          description: this.currentItemSub.description,
          // cat_type_new: parent.cat_type_new,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.quickTopicSearch();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit-topic");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật topic ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: this.currentItemSub.name,
          status: this.currentItemSub.status,
          parent_id: this.currentItemSub.parent_id,
          sort_order: this.currentItemSub.sort_order,
          description: this.currentItemSub.description,
          cat_type_new: parent.cat_type_new,
          cat_type: 1,
          created_at: userName,
          updated_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/categories", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.quickTopicSearch();
          this.$bvModal.hide("modal-edit-topic");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới topic thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới topic ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async isValid(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      if (item.cat_type_new == undefined || item.cat_type_new < 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn loại danh mục.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      return true;
    },
    async loadCategories() {
      try {
        this.loading(true);
        useJwt.get("portal/categories?filter=" + this.searchQuery).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
            this.categoriesSelect = [];
            this.items.forEach(item => {
              this.categoriesSelect.push({'id': item.id, 'text': item.name});
            });
          }

          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }

    },
    async quickSearch() {
      this.loadCategories();
    },
    async quickTopicSearch() {
      try {

        this.loading(true);
        let listCatIds = [];
        this.rowSelection.forEach(function (item) {
          listCatIds.push(item.id);
        });
        useJwt.get("portal/getTopics?filter=" + this.searchQuery + '&ids=' + listCatIds).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.itemSubs = result.result;
            this.totalRecordSubs = result.totalRecords;
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    }
  },

  mounted() {
    this.loadCategories();
    this.quickTopicSearch();
    this.isSubmit = false;
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      totalRecordSubs: 0,
      items: [],
      itemSubs: [],
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"}
      ],
      typeCategories: [
        {id: 0, text: "Chính sách"},
        {id: 4, text: "Gói cước"},
        {id: 1, text: "Quy trình & quy định"},
        {id: 2, text: "Khuyến mãi"},
        {id: 3, text: "Hướng dẫn sử dụng"},
        {id: 5, text: "Q&A"}
      ],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchQueryTopic: "",
      currentItem: {},
      currentItemSub: {},
      categoriesSelect: [],
      rowSelection: [],
      rowSelectionSub: [],
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên danh mục",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            disabled: true
          },
          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ],
        fieldSubs: [
          {field: "action", label: "Thao tác", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên chủ đề",
            required: true,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            required: true,
            disabled: true,
          },
          {
            field: "statusName",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.readonly {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

table.vgt-table td {
  min-width: 100px;
}
</style>
